export var DEFAULT_CONFIG = {
  env: 'production',
  locale: 'en-US'
};
export var ALLOWED_CHILD_EVENTS = ['value', 'child_added', 'child_removed', 'child_changed', 'child_moved'];
export var DEFAULT_REQUIRED_IMAGE_SIZE = 240;